import {getKonekoCapabilities, KONEKO_CAP} from "@/config/konekoVisibility";
import {teamRosterAdminUsernames} from "@/Utilites/teamRosterAdmin";

function normalizeUsername(profile) {
  return String((profile && profile.username) || "")
    .trim()
    .toLowerCase();
}

/** May edit payroll monthly treatment on Team member cards. */
export function userCanEditPayrollTeamFields(profile) {
  const u = normalizeUsername(profile);
  if (!u) return false;
  if (
    teamRosterAdminUsernames.some((a) => String(a).trim().toLowerCase() === u)
  ) {
    return true;
  }
  const caps = getKonekoCapabilities(profile);
  return !!caps[KONEKO_CAP.navPayroll];
}
